import { ChangeDetectorRef, Component, InjectFlags, inject } from '@angular/core';
import { MwcModalRef, NZ_MODAL_DATA } from 'mwc/modal';
import { ArticleService } from 'src/app/services/article/article.service';
import { AddOrRemoveAsFavoriteTemplateRequest, AddOrRemoveAsFavoriteTemplateResponse, Template } from 'src/app/_shared/models/article';

@Component({
  selector: 'app-template-details-modal',
  templateUrl: './template-details-modal.component.html',
  styleUrls: ['./template-details-modal.component.scss']
})
export class TemplateDetailsModalComponent {
  readonly mwcModalData: { template: Template } = inject(NZ_MODAL_DATA, InjectFlags.Optional);
  data: Template = this.mwcModalData?.template;
  isLoading = false;
  private favoriteChanged = false;

  constructor(
    private articleService: ArticleService,
    private modalRef: MwcModalRef,
    private ngChangeDetectorRef: ChangeDetectorRef) {
  }

  getWhyUseParts(whyUseText: string): { title: string, description: string } {
    const cleaned = whyUseText.replace(/\d/g, (match, offset, str) => {
      const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
      const before = str[offset - 1] || "";
      const after = str[offset + 1] || "";
      // Keep the digit if it's surrounded by '-' or '–'
      if ((before === "-" || before === "–" || (before != "" && numbers.includes(+before))) || (after === "-" || after === "–" || (after != "" && numbers.includes(+after)))) {
        return match; // keep the digit
      }
      return ""; // otherwise remove the digit
    });
    const [titlePart, ...descriptionParts] = cleaned.replace(".", "").split(":");
    return {
      title: titlePart.trim(),
      description: descriptionParts.join(":").trim()
    };
  }

  toggleFavorite() {
    this.isLoading = true;
    const request = new AddOrRemoveAsFavoriteTemplateRequest();
    request.templateId = this.data.templateId;
    this.articleService.AddOrRemoveAsFavoriteTemplate<AddOrRemoveAsFavoriteTemplateResponse>(request)
      .subscribe((response: AddOrRemoveAsFavoriteTemplateResponse) => {
        this.isLoading = false;
        if (response != null && response.errorCode == 0 && response.success) {
          this.data.isFavorite = !this.data.isFavorite;
          this.favoriteChanged = true;
        }
        this.ngChangeDetectorRef.detectChanges();
      }, () => {
        this.isLoading = false;
        this.ngChangeDetectorRef.detectChanges();
      });
  }

  startTemplate() {
    this.modalRef.close({ action: 'start', template: this.data, favoriteChanged: this.favoriteChanged });
  }

  close() {
    this.modalRef.close({ action: 'close', favoriteChanged: this.favoriteChanged });
  }
}
